// PageHeader component - Converted from components/PageHeader.vue
// Page header with title and breadcrumb
// Converted: <template> -> JSX, defineProps -> function props, {{ title }} -> {title}, NuxtLink -> Link
// Converted: :style binding -> style prop
import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from '../assets/images/backgrounds/page-header-contact.png';

// Converted from Vue: defineProps -> function parameter with destructuring
const PageHeader = ({ title }) => {
  return (
    <section className="page-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="container">
        <h2>{title}</h2>
        <ul className="thm-breadcrumb list-unstyled">
          <li>
            <Link to="/">Accueil</Link>
          </li>
          <li><span>{title}</span></li>
        </ul>
      </div>
    </section>
  );
};

export default PageHeader;
